// src/layouts/MainLayout.jsx
import { Outlet } from 'react-router-dom';
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import PageMetadata from '../components/PageMetadata';

export default function MainLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <PageMetadata />
      <NavBar />

      {/* main grows to fill remaining height */}
      <main className="flex-1">
        {/* <div className="mx-auto max-w-7xl px-6"> */}
          <Outlet />
        {/* </div> */}
      </main>

      <Footer />
    </div>
  );
}
